// extracted by mini-css-extract-plugin
export default {"futureAncestorsContainer":"futureancestors_futureAncestorsContainer__0F4IB","speaker":"futureancestors_speaker__ULhgX","topic":"futureancestors_topic__oP8en"};